import GetLoading from "../../../share/getLoading";
// ApproverAssignments.js - Complete fixed version
import React, { useEffect, useRef, useState } from "react";
import debounce from "lodash.debounce";
import {
  PlusCircleOutlined,
  EditFilled,
  CloseOutlined,
  SearchOutlined,
  ReloadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Table,
  Button,
  Space,
  Tag,
  Popconfirm,
  message,
  Input,
  Select,
  Modal,
  Form,
  Switch,
  Avatar,
  Spin,
} from "antd";
 
import { request } from "../../../share/request";
import { getStatusContent, getTageStyle } from "../../../share/getStatusContent";
import { boxHeader, boxHeaderTagText } from "../../../styles/boxShadow";

import { getCurrentUser } from "../../../share/getProfile";
import { formateDateSystem, linkPath } from "../../../share/helper";

const { Option } = Select;

const ApproverAssignments = () => {
  const getProfile = getCurrentUser();
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [filterParam, setFilterParam] = useState({
    search: "",
    status: "all",
  });
  const [txtSearch, setTxtSearch] = useState("");
  
  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingApprovers, setLoadingApprovers] = useState(false);
  const [loadingModalOpen, setLoadingModalOpen] = useState(false);
  const [form] = Form.useForm();

  // Joiner search state
  const [objFilterJoiner, setObjFilterJoiner] = useState({
    search: "",
    org_code: getProfile.org_code,
  });

// Helper function to get full image URL
const getImageUrl = (imagePath) => {
  console.log("Getting image URL for path:", imagePath);
  
  // If no image path, return null
  if (!imagePath) {
    return null;
  }
  
  // If image path already starts with http, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If image path already starts with /, don't add extra slash
  if (imagePath.startsWith('/')) {
    return linkPath + imagePath;
  }
  
  // If image path is 'fileimage_update-xxx', it might be a filename
  // Check if linkPath already ends with /
  if (linkPath.endsWith('/')) {
    return linkPath + imagePath;
  } else {
    return linkPath + '/' + imagePath;
  }
};
  // Get list of approver assignments
  const getList = async () => {
    const param = new URLSearchParams({
      org_code: getProfile.org_code,
      search: filterParam.search,
      status: filterParam.status,
    });
    try {
      const res = await request("approver-assignments?" + param.toString(), "get", {});
      await new Promise((resolve) => setTimeout(resolve, 400));
      if (res && res.success) {
        setList(res.data || []);
      } else if (res && res.data) {
        setList(res.data);
      }
    } catch (error) {
      console.log("Error fetching approver assignments:", error);
      message.error("មិនអាចទាញយកទិន្នន័យបានទេ");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [filterParam]);

  // Load departments
  const loadDepartments = async () => {
    setLoadingDepartments(true);
    try {
      const param = new URLSearchParams({
        org_code: getProfile.org_code,
      });
      const res = await request("departmentall?" + param.toString(), "get", {});
      
      let deptList = [];

      if (res && res.listdepartment && Array.isArray(res.listdepartment)) {
        deptList = res.listdepartment;
      } else if (res && Array.isArray(res)) {
        deptList = res;
      } else if (res && res.data && Array.isArray(res.data)) {
        deptList = res.data;
      } else if (res && res.api_departments && Array.isArray(res.api_departments)) {
        deptList = res.api_departments;
      } else if (res && res.list && Array.isArray(res.list)) {
        deptList = res.list;
      }
      
      const formattedDepartments = deptList.map(dept => ({
        id: dept.code,
        code: dept.code,
        name: dept.department_name || dept.name,
        name_kh: dept.department_name,
        name_en: dept.department_en
      }));
      
      setDepartments(formattedDepartments);
      
      if (formattedDepartments.length === 0) {
        message.warning("មិនមានទិន្នន័យនាយកដ្ឋាន");
      }
    } catch (error) {
      console.log("Error loading departments:", error);
      message.error("មិនអាចទាញយកនាយកដ្ឋានបានទេ");
    } finally {
      setLoadingDepartments(false);
    }
  };

 // Load approvers - store both username (for display) and actual user ID
const loadApprovers = async (filter = {}) => {
  setLoadingApprovers(true);
  try {
    const param = new URLSearchParams({
      search: filter.search || "",
      org_code: filter.org_code || getProfile.org_code,
    });

    if (filter.dept_code) {
      param.append("dept_code", filter.dept_code);
    }

    const res = await request(`lettersjoiner?${param.toString()}`, "get", {});
    console.log("Approver list response:", res);
    if (res && res.api_server_list_joiner && Array.isArray(res.api_server_list_joiner)) {
      const approverList = res.api_server_list_joiner.map(staff => ({
        user_id: staff.id,
        username: staff.staff_id_number,
        name: staff.staffname_kh1,
        position: staff.position_kh,
        org_code: staff.org_code,
        image: staff.image || null, // Handle null/undefined image
        image_url: staff.image ? getImageUrl(staff.image) : null,
        label: `${staff.staffname_kh1} | ${staff.position_kh}`,
      }));
      setApprovers(approverList);
      return approverList;
    }
    return [];
  } catch (error) {
    console.log("Error loading approvers:", error);
    message.error("មិនអាចទាញយកបញ្ជីអ្នកអនុម័តបានទេ");
    return [];
  } finally {
    setLoadingApprovers(false);
  }
};

  // Debounced search
  const handleApproverSearch = useRef(
    debounce((inputValue, currentFilter) => {
      loadApprovers({ ...currentFilter, search: inputValue });
    }, 300)
  ).current;

  // Handle delete
  const handleDelete = async (item) => {
    setLoadingSpin(true);
    try {
      const res = await request(`approver-assignments/${item.id}`, "DELETE", {});
      if (res && res.isOk === true) {
        message.success("លុបបានជោគជ័យ");
        getList();
      } else {
        message.error(res?.message || "លុបមិនបានសម្រេច");
      }
    } catch (error) {
      console.error("Error while deleting:", error);
      message.error("មានបញ្ហាក្នុងការលុប");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Handle toggle status
  const handleToggleStatus = async (item) => {
    const newStatus = item.is_active === 1 ? 0 : 1;
    setLoadingSpin(true);
    try {
      const res = await request(`approver-assignments/${item.id}/toggle-status`, "PATCH", {
        is_active: newStatus === 1,
      });
      if (res && res.isOk === true) {
        message.success(newStatus === 1 ? "បានដំណើរការវិញ" : "បានបិទដំណើរការ");
        getList();
      } else {
        message.error(res?.message || "មានបញ្ហា");
      }
    } catch (error) {
      console.error("Error while toggling status:", error);
      message.error("មានបញ្ហា");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Handle search
  const handleSearch = (value) => {
    setTxtSearch(value);
    setFilterParam(prev => ({ ...prev, search: value }));
  };

  // Handle status filter
  const handleStatusFilter = (status) => {
    setFilterParam(prev => ({ ...prev, status }));
  };

  // Open add modal
  const handleAddNew = async () => {
    setEditingId(null);
    form.resetFields();
    form.setFieldsValue({ is_active: true });
    setLoadingModalOpen(true);
    
    try {
      await loadDepartments();
      await loadApprovers();
      setIsModalVisible(true);
    } catch (error) {
      console.log("Error opening add modal:", error);
      message.error("មិនអាចបើកទម្រង់បានទេ");
    } finally {
      setLoadingModalOpen(false);
    }
  };

  // Open edit modal
  const handleEdit = async (item) => {
    console.log("Editing item:", item);
    setEditingId(item.id);
    setLoadingModalOpen(true);
    
    try {
      await loadDepartments();
      const approverList = await loadApprovers({ dept_code: item.department_id });
      
      console.log("Approver list loaded:", approverList);
      console.log("Looking for approver with username:", item.approver_id);
      
      // Find the approver by username (item.approver_id is the username from backend)
      const selectedApprover = approverList.find(a => a.username === item.approver_id);
      
      if (selectedApprover) {
        console.log("Found approver:", selectedApprover);
        form.setFieldsValue({
          department_id: item.department_id,
          approver_id: selectedApprover.user_id,
          is_active: item.is_active === 1,
        });
      } else {
        console.warn("Approver not found in list, trying to find by numeric ID");
        // Try to find by numeric ID
        const approverById = approverList.find(a => a.user_id === parseInt(item.approver_id));
        if (approverById) {
          form.setFieldsValue({
            department_id: item.department_id,
            approver_id: approverById.user_id,
            is_active: item.is_active === 1,
          });
        } else {
          console.warn("Could not find approver, setting only department and status");
          form.setFieldsValue({
            department_id: item.department_id,
            is_active: item.is_active === 1,
          });
        }
      }
      
      setIsModalVisible(true);
    } catch (error) {
      console.log("Error opening edit modal:", error);
      message.error("មិនអាចបើកទម្រង់កែប្រែបានទេ");
    } finally {
      setLoadingModalOpen(false);
    }
  };

  // Handle department change in modal
  const handleDepartmentChange = async (departmentId) => {
    form.setFieldsValue({ approver_id: undefined });
    const updatedFilter = { ...objFilterJoiner, search: "", dept_code: departmentId || undefined };
    setObjFilterJoiner(updatedFilter);
    await loadApprovers(updatedFilter);
  };

  // Handle modal submit
  const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();
      
      const submitData = {
        dept_code: values.department_id,
        user_id: values.approver_id,
        is_active: values.is_active ? 1 : 0,
        org_code: getProfile.org_code,
        usercreate: getProfile.fullname,
      };

      console.log("Submitting data:", submitData);

      setLoadingSpin(true);
      
      let res;
      if (editingId) {
        res = await request(`approver-assignments/${editingId}`, "PUT", submitData);
      } else {
        res = await request("approver-assignments", "POST", submitData);
      }

      if (res && res.isOk === true) {
        message.success(editingId ? "កែប្រែបានជោគជ័យ" : "បង្កើតបានជោគជ័យ");
        setIsModalVisible(false);
        form.resetFields();
        getList();
      } else {
        throw new Error(res?.message || "មានបញ្ហាក្នុងការរក្សាទុក");
      }
    } catch (error) {
      console.log("Submit error:", error);
      message.error(error.message || "មានបញ្ហាក្នុងការរក្សាទុក");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Handle modal cancel
  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setEditingId(null);
  };

  // Custom render for select option to show image and details
  const renderSelectOption = (approver) => {
    const imageUrl = getImageUrl(approver.image);
    console.log('image from ', imageUrl)
    return (
      <Space>
        <Avatar 
          src={imageUrl}
          icon={!imageUrl && <UserOutlined />}
          size="medium"
        />
        <div>
          <div>{approver.name}  |   {approver.position}</div>
         
        </div>
      </Space>
    );
  };

  // Table columns
  const columns = [
    {
      key: "id",
      title: "ល.រ",
      dataIndex: "id",
      width: 70,
    },
    {
      key: "department_name",
      title: "នាយកដ្ឋាន",
      dataIndex: "department_name",
      render: (value) => {
        return <Tag color="blue">{value || "-"}</Tag>;
      },
    },
    {
      key: "approver",
      title: "អ្នកអនុម័ត",
      render: (_, record) => {
        const imageUrl = getImageUrl(record.user_image);
        return (
          <Space>
            <Avatar 
              src={imageUrl}
              icon={!imageUrl && <UserOutlined />}
              size="medium"
            />
            <div>
              <div><strong>{record.approver_name || "-"}</strong></div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {record.position || "-"}
              </div>
            </div>
          </Space>
        );
      },
    },
   
    {
      key: "is_active",
      title: "ស្ថានភាព",
      dataIndex: "is_active",
      render: (value) => {
        return value === 1 ? (
          <Tag color="success">សកម្ម</Tag>
        ) : (
          <Tag color="error">អសកម្ម</Tag>
        );
      },
    },
    {
      key: "created_at",
      title: "កាលបរិច្ឆេទតែងតាំង",
      dataIndex: "created_at",
      render: (value) => formateDateSystem(value),
    },
    {
      key: "usercreate",
      title: "អ្នកបង្កើត",
      dataIndex: "usercreate",
      render: getTageStyle,
    },
    {
      key: "action",
      title: "សកម្មភាព",
      dataIndex: "action",
      width: 180,
      render: (_, item) => {
        return (
          <Space>
            <Button
              icon={<EditFilled />}
              type="primary"
              onClick={() => handleEdit(item)}
              loading={loadingModalOpen && editingId === item.id}
              size="small"
            />
            <Button
              type="primary"
              icon={item.is_active === 1 ? <CloseOutlined /> : <ReloadOutlined />}
              onClick={() => handleToggleStatus(item)}
              style={{ 
                background: item.is_active === 1 ? "#faad14" : "#52c41a",
                borderColor: item.is_active === 1 ? "#faad14" : "#52c41a"
              }}
              loading={loadingSpin}
              size="small"
            />
            <Popconfirm
              placement="leftTop"
              title="លុប"
              description="តើអ្នកប្រាកដថាចង់លុបការតែងតាំងនេះមែនទេ?"
              okText="យល់ព្រម"
              cancelText="បោះបង់"
              onConfirm={() => handleDelete(item)}
            >
              <Button danger type="primary" icon={<CloseOutlined />} loading={loadingSpin} size="small" />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <div>
      {loadingSpin && (
        <div className="sprinSave">
          <GetLoading />
        </div>
      )}

      <div style={boxHeader}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px", width: "100%" }}>
          <Space>
            {boxHeaderTagText("ការគ្រប់គ្រង់ ការតែងតាំងអ្នកអនុម័ត")}
          </Space>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <Input
              placeholder="ស្វែងរកតាមនាយកដ្ឋាន ឬឈ្មោះ..."
              prefix={<SearchOutlined />}
              value={txtSearch}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
              style={{ width: 250 }}
            />
            <Select
              value={filterParam.status}
              onChange={handleStatusFilter}
              style={{ width: 150 }}
              placeholder="ស្ថានភាព"
            >
              <Option value="all">ទាំងអស់</Option>
              <Option value="active">សកម្ម</Option>
              <Option value="inactive">អសកម្ម</Option>
            </Select>
            <Button
              className="buttonstylekhmer"
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={handleAddNew}
              loading={loadingModalOpen && editingId === null}
            >
              បង្កើតថ្មី
            </Button>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table
            pagination={{
              pageSize: 10,
              showTotal: (total) => `សរុប ${total}`,
            }}
            columns={columns}
            size="small"
            dataSource={list}
            rowKey="id"
          />
        )}
      </div>

      <Modal
        title={editingId ? "កែប្រែការតែងតាំងអ្នកអនុម័ត" : "បង្កើតការតែងតាំងអ្នកអនុម័តថ្មី"}
        open={isModalVisible}
        onOk={handleModalSubmit}
        onCancel={handleModalCancel}
        width={600}
        okText={editingId ? "រក្សាទុក" : "បង្កើត"}
        cancelText="បោះបង់"
        confirmLoading={loadingSpin}
      >
        <Spin spinning={loadingModalOpen} tip="កំពុងផ្ទុក...">
          <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
            <Form.Item
              name="department_id"
              label="នាយកដ្ឋាន"
              rules={[
                { required: true, message: "សូមជ្រើសរើសនាយកដ្ឋាន" },
              ]}
            >
              <Select
                placeholder="ជ្រើសរើសនាយកដ្ឋាន"
                onChange={handleDepartmentChange}
                showSearch
                optionFilterProp="children"
                size="large"
                loading={loadingDepartments}
                notFoundContent={loadingDepartments ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
              >
                {departments.map((dept) => (
                  <Option key={dept.code} value={dept.code}>
                    {dept.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="approver_id"
              label="អ្នកអនុម័ត"
              rules={[
                { required: true, message: "សូមជ្រើសរើសអ្នកអនុម័ត" },
              ]}
            >
              <Select
                placeholder="ជ្រើសរើសអ្នកអនុម័ត"
                showSearch
                size="large"
                loading={loadingApprovers}
                notFoundContent={loadingApprovers ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                onSearch={(inputValue) => handleApproverSearch(inputValue, objFilterJoiner)}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {approvers.map((approver) => (
                  <Option 
                    key={approver.user_id} 
                    value={approver.user_id}
                    label={approver.label}
                  >
                    {renderSelectOption(approver)}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="is_active"
              label="ស្ថានភាព"
              valuePropName="checked"
            >
              <Switch
                checkedChildren="សកម្ម"
                unCheckedChildren="អសកម្ម"
                defaultChecked={true}
              />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default ApproverAssignments;